import React from 'react'
import CommunityImpactBuilder from 'components/Home/CommunityImpactBuilder'

export default function Slider2({data}) {
    const {slider2Title, slider2Slides} = data
  return (
    <CommunityImpactBuilder
          feedbacksTitle={slider2Title}
          feedbacksHome={slider2Slides}
        />
  )
}
